import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/Birmingham_University.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>University of Birmingham Dubai</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>The University of Birmingham's first international campus — a 50,000 sqm crescent-shaped building inspired by the
                university's historic Aston Webb buildings in Birmingham. Designed by Hopkins Architects, accommodating up to 2,900
                students and 400 staff. Opened 2021.</p>
              <p>MAIN CONTRACTOR : Khansaheb Civil Engineering</p>
              <p>MEP CONTRACTOR : BK Gulf</p>
              <p>GEMCO SCOPE OF WORKS : Central plant room works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one